'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _getValidLangKey = require('./getValidLangKey');

var _getValidLangKey2 = _interopRequireDefault(_getValidLangKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get current language key from url.
 * @func
 * @param {[String]} langs allowed lang keys ['en', 'fr', 'pt']
 * @param {String} defaultLangKey default browser language key
 * @param {String} url browser url 
 * @returns {String} current langKey
 */
var getCurrentLangKey = (0, _ramda.curry)(function (langs, defaultLangKey, url) {
  var langKey = url.split('/')[1];
  return (0, _getValidLangKey2.default)(langs, defaultLangKey, langKey);
});

exports.default = getCurrentLangKey;


//////////////////
// WEBPACK FOOTER
// ./~/ptz-i18n/dist/getCurrentLangKey.js
// module id = 223
// module chunks = 34471704633725 35783957827783 114276838955818 216468464745311